import { Component, Input } from "@angular/core";
import { ModelService } from "../Services/model.service";
import { ValidFeature } from "../Model/ValidFeature";
import { ValidFeatureValue } from "../Model/ValidFeatureValue";
import { TranslateService } from "@ngx-translate/core";


@Component({
  selector: "validFeature",
  templateUrl: "validFeature.component.html"
})
export class ValidFeatureComponent {
  @Input() ValidFeatures: ValidFeature[];

  validFeatureValues: ValidFeatureValue[] = []

  constructor(public modelService: ModelService, public translate: TranslateService) {

  }

}
